import { CURRENCY } from '@/lib/constants';

const percentFormat = new Intl.NumberFormat(CURRENCY.locale, {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

// "75", "116,67", "33,3" — no trailing zeros, so a goal of 40 reads "40%" and not "40,00%". The API sends
// percentages as decimal strings ("75.00") already rounded to two places; nothing here rounds further.
export const formatPercent = (value: number | string): string => {
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  // `+ 0` turns a negative zero into 0 — Intl would print "-0".
  return `${percentFormat.format(parsed + 0)}%`;
};

const wholeFormat = new Intl.NumberFormat(CURRENCY.locale, { maximumFractionDigits: 0 });

// For a figure read at a glance (the verdict, Utilizado, a group's use): whole percents, "52%" for 51,76. Rounding
// never carries a value across 100 — 99,6 reads "99%" and 100,4 reads "101%" — so it can't hide which side of a
// limit a group is on. Exactly 100 reads "100%".
export const formatPercentGlance = (value: number | string): string => {
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  let whole = Math.round(parsed);
  if (parsed < 100 && whole >= 100) whole = 99;
  if (parsed > 100 && whole <= 100) whole = 101;
  return `${wholeFormat.format(whole + 0)}%`;
};
